import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import styled from 'styled-components';
import { TimeIcon } from '../icon/icon';
import { formatNumber, getRandomColor } from '../../utils/util';

interface CompanyScheduleDto {
  work: string; // 작업 형태
  target: string; // 도착시
  amount: number; // 금액
  wanted: string; // 수배 차량
}

// 컴포넌트에 전달할 props 인터페이스 정의
interface ManagerHomeSectionProps {
  schedules: CompanyScheduleDto[];
}

export const ManagerHomeSection = ({
  schedules = [],
}: ManagerHomeSectionProps) => {
  const settings = {
    dots: true,
    infinite: schedules.length > 3, // 항목이 하나일 때 infinite를 false로 설정
    speed: 500,
    slidesToShow: 1, // 3개 이하일 경우 슬라이드를 하나만 보여줌
    rows: schedules.length > 2 ? 3 : 2, // 4개 이상일 경우에만 3개 행을 보여줌
    slidesPerRow: 1,
  };

  return (
    <Wrap>
      {schedules && schedules.length > 0 ? (
        <Slider {...settings}>
          {schedules.map((item, i) => (
            <div className="carousel-item" key={i}>
              <Inner backgroundColor={getRandomColor(i)}>
                {' '}
                {/* 각 요소에 랜덤한 색상 적용 */}
                <div className="tp">
                  <TypeBadge workType={item.work}>
                    {item.work === 'full' ? '전일' : '반일'}
                  </TypeBadge>
                  <p>{item.wanted}</p>
                </div>
                <div className="bt">
                  <div className="icon-box-wrap">
                    <div className="icon-box">
                      <TimeIcon />
                    </div>
                    <span className="time">{item.target}</span>
                  </div>
                  <div className="amount">
                    <span className="won">₩</span>
                    <span className="price">{formatNumber(item.amount)}</span>
                  </div>
                </div>
              </Inner>
            </div>
          ))}
        </Slider>
      ) : (
        <div className="carousel-item">
          <Inner backgroundColor={getRandomColor(0)}>
            <span className="no-data">일정이 없습니다.</span>
          </Inner>
        </div>
      )}
    </Wrap>
  );
};

// 스타일 컴포넌트 정의
const Wrap = styled.section`
  .carousel-item {
    padding: 0.6rem 0;
  }
  .no-data {
    color: ${(props) => props.theme.textWhiteColor};
    font-size: 1.6rem;
  }
`;

const Inner = styled.div<{ backgroundColor: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 2.4rem 1.9rem 2.2rem;
  border-radius: 1.6rem;
  background-color: ${(props) => props.backgroundColor};
  .tp {
    display: flex;
    gap: 0.9rem;
    align-items: center;
    p {
      color: ${(props) => props.theme.textWhiteColor};
      font-size: 1.6rem;
      font-weight: 600;
    }
  }
  .bt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-box-wrap {
      display: flex;
      align-items: center;
      gap: 0.8rem;
      .time {
        font-size: 1.3rem;
        font-weight: 600;
      }
    }
    .amount {
      font-size: 1.6rem;
      font-weight: 600;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      gap: 0.2rem;
      .won {
        font-size: 1.2rem;
        color: ${(props) => props.theme.workingTypeColor};
      }
      .price {
        line-height: 2rem;
      }
    }
    > * {
      color: ${(props) => props.theme.textWhiteColor};
    }
  }
`;

const TypeBadge = styled.span<{ workType: string }>`
  width: 4.2rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 1.1rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  line-height: 2.2rem;
  background-color: ${(props) =>
    props.workType === 'full' ? '#00ffba' : '#FFB400'};
  color: ${(props) => props.theme.textBlackColor};
`;
